export const recurringPaymentSection = '/recurring-payment';

export const recurringPaymentPath = recurringPaymentSection + '/:accessKey';
export const recurringPaymentSuccessPath = recurringPaymentSection + '/:accessKey/success';
export const recurringPaymentProcessingPath = recurringPaymentSection + '/:accessKey/processing';
export const recurringPaymentUpdatePath =
  recurringPaymentSection + '/:recurringPaymentId/update-payment-method';

export const recurringPaymentListPath = recurringPaymentSection;
export const recurringPaymentCreatePath = recurringPaymentSection + '/detail/create';
export const recurringPaymentDetailPath = (id: string) => `${recurringPaymentSection}/detail/${id}`;
export const recurringPaymentDetailRoute = recurringPaymentSection + '/detail/:id';
